import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { NumericFormat } from "react-number-format";
import { Masked } from "work/_shared/masked-fields";
import CommentsButton from "work/proposals/comments/_view/comments-button";
import CommentThread from "work/proposals/comments/threads/comment-thread";
import Proposal from "work/proposals/proposal";
import ProposalField from "work/proposals/proposal-fields/proposal-field";

const ComponentContainer = styled("div")(({ theme }) => ({
  height: "100%",
  margin: theme.spacing(2, 0, 4, 0),
}));

type DiscountTabProps = {
  proposal: Proposal;
  commentThreads?: CommentThread[];
  onCommentsClicked: (field: ProposalField, title?: string) => void;
};

export default function DiscountTab(props: Readonly<DiscountTabProps>) {
  const { proposal, commentThreads, onCommentsClicked } = props;

  const discount = Masked.isPresentNotMasked(proposal.discount) ? proposal.discount.value : 0;

  return (
    <ComponentContainer>
      <NumericFormat
        name="discount"
        label="Discount"
        customInput={TextField}
        allowNegative={false}
        value={Number(discount * 100)}
        suffix="%"
        type="text"
        thousandSeparator={false}
        decimalScale={2}
        disabled={true}
        slotProps={{
          input: {
            endAdornment: (
              <CommentsButton
                commentThreads={commentThreads}
                field={ProposalField.Discount}
                muted
                toolTip={
                  commentThreads?.some((thread) => thread.field.isEqualTo(ProposalField.Discount))
                    ? "Comments"
                    : "No Comments"
                }
                onCommentsClicked={
                  onCommentsClicked
                    ? () => {
                        onCommentsClicked(ProposalField.Discount);
                      }
                    : undefined
                }
              />
            ),
          },
        }}
      />
    </ComponentContainer>
  );
}
